import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import Logger from 'browser-logging/src/browser/Logger';

import App from './App';

Logger.init({
  appName: `${(window as any).orgName} Dashboard Client`.replaceAll(' ', '_'),
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
